var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51.688a.812.812 0 0 1 1.133 0l4.539 4.83a.775.775 0 0 1 0 1.11l-4.539 4.83a.812.812 0 0 1-1.133 0 .775.775 0 0 1 0-1.111l3.172-3.489H1.384a.793.793 0 0 1-.801-.785c0-.434.359-.786.801-.786h9.298L7.51 1.8a.775.775 0 0 1 0-1.11Z",
    fill: "currentColor"
  })));
};
export default SvgArrowRight;